/*
 * @Description: 
 * @Version: 2.0
 * @Autor: chenkang
 * @Date: 2021-09-01 17:46:54
 * @LastEditors: yinwenxuan yinwenxuan@vip56.cn
 * @LastEditTime: 2026-01-30 15:50:44
 */
import { Post, Get, Patch, Put, Delete, Download, ax } from './http_pad';
import { type } from './interface';
import qs from 'qs';
export namespace TbTbHandover {
    /**
     * 交接班并登出
     */
    export var PostHandover = (body: any): Promise<any> => {
        return Post(`/api/TbHandover/PostHandoverV3`, body);
    };
    /**
    * 交接班查询
    */
    export var GetHandoverInfo = (body: any): Promise<any> => {
        return Get(`/api/TbHandover/GetHandoverInfoNew`, body);
    };
    /**
    * 交接班获取商品销售报表
    */
    export var GetHandoverGoods = (body: any): Promise<any> => {
        return Get(`/api/TbHandover/GetHandoverGoodsNew`, body);
    };
    /**
    * 新交接班获取商品销售报表
    */
    export var GetNewHandoverGoods = (body: any): Promise<any> => {
        return Get(`/api/TbHandover/GetNewHandoverGoodsV3`, body);
    };
    /**
    * 获取员工交接班报表列表
    */
    export var GetTbHandoverList = (body: any): Promise<any> => {
        return Get(`/api/TbHandover/GetTbHandoverList`, body);
    };
     /**
    * 获取员工交接班报表列表-统计
    */
    export var GetHandoverTotal = (body: any): Promise<any> => {
        return Get(`/api/TbHandover/GetHandoverTotal`, body);
    };
     /**
    * 获取交接班开始时间
    */
    export var GetHandowerTime = (body: any): Promise<any> => {
        return Get(`/api/TbHandover/GetHandowerTime`, body);
    };

}



// WEBPACK FOOTER //
// ./src/http/api_TbTbHandover.ts